import { TextField, type TextFieldProps } from '@mui/material'
import { useLayoutEffect, useRef } from 'preact/hooks'
import { reformat } from './format'

/** A phone number input, grouped as it is typed (`06 12 34 56 78`). */
export function PhoneField({
  value,
  onValue,
  ...props
}: Omit<TextFieldProps, 'value' | 'onChange' | 'onInput' | 'type'> & {
  value: string
  onValue: (value: string) => void
}) {
  const input = useRef<HTMLInputElement>(null)
  const caret = useRef<number | null>(null)
  useLayoutEffect(() => {
    if (caret.current === null || document.activeElement !== input.current) return
    input.current?.setSelectionRange(caret.current, caret.current)
    caret.current = null
  })
  return (
    <TextField
      {...props}
      type="tel"
      inputRef={input}
      value={value}
      onInput={(e) => {
        const field = e.target as HTMLInputElement
        const erased = (e as InputEvent).inputType === 'deleteContentBackward'
        const next = reformat(
          field.value,
          field.selectionStart ?? field.value.length,
          erased,
          value,
        )
        caret.current = next.caret
        // The input may already show the formatted value, which would not re-render it
        field.value = next.value
        field.setSelectionRange(next.caret, next.caret)
        onValue(next.value)
      }}
    />
  )
}
